module.exports = __webpack_public_path__ + "img/points-title.830373fb.png";